import { useCallback } from 'react'

export const useAppLocalStorage = (): {
  setLocalStorage: (items: Record<string, string | null | undefined>) => void
  removeLocalStorage: (keys: string | string[]) => void
} => {
  // Set or update one or more keys
  const setLocalStorage = useCallback((items: Record<string, string | null | undefined>) => {
    Object.entries(items).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        localStorage.removeItem(key)
      } else {
        localStorage.setItem(key, value)
      }
    })
  }, [])

  // Remove one or more keys
  const removeLocalStorage = useCallback((keys: string | string[]) => {
    (Array.isArray(keys) ? keys : [keys]).forEach(key => {
      localStorage.removeItem(key)
    })
  }, [])

  return { setLocalStorage, removeLocalStorage }
}

// Usage in your component:
// const { setLocalStorage, removeLocalStorage } = useAppLocalStorage()
// setLocalStorage({ projectId: '123', termId: '456' })
// removeLocalStorage(['projectId', 'termId'])
